import React, { PropsWithChildren } from 'react'

import { useWindowResize } from '../../../../utils/domUtils'
import { CommonModalProps } from '../types'
import { ConfirmModalDesktop } from './ConfirmModalDesktop'
import { ConfirmModalMobile } from './ConfirmModalMobile'

export interface ConfirmModalProps extends PropsWithChildren<CommonModalProps> {
  isValid?: boolean
  renderFooter?(props: ConfirmModalProps): React.ReactNode[]
  onConfirm?(): void
  hasCloseButton?: boolean
}

export const ConfirmModal: React.FC<ConfirmModalProps> = (props) =>
  useWindowResize() ? <ConfirmModalMobile {...props} /> : <ConfirmModalDesktop {...props} />
